import { useCallback } from 'react'
// custom components
import Label from 'Design/components/Label'
import Input from 'Design/components/Input'
import Button from 'Design/components/Button'
import { EntryFormError } from 'Layout/EntryForm'
import FormControl from 'Design/components/FormControl'
import FormErrorText from 'Design/components/FormErrorText'
import Modal, { ModalBody, ModalHeader } from 'Design/components/Modal/Modal'
// form & form validation schema
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import apiTokenValidationSchema from './api-token-validation-schema'
// services
import { useCreateTokenMutation } from '../rest-api.service'
// utils
import toast from 'react-hot-toast'

const CreateToken = ({ isOpen, hide }) => {
  const [createToken, createTokenResult] = useCreateTokenMutation()

  const {
    handleSubmit,
    register,
    setError,
    clearErrors,
    reset,
    formState: { errors, isSubmitting }
  } = useForm({
    defaultValues: {
      name: ''
    },
    resolver: yupResolver(apiTokenValidationSchema)
  })

  const onClose = useCallback(hide, [hide])

  const processError = (err = {}) => {
    switch (err.type) {
      case 'API_TOKEN_NAME_LENGTH_ERR':
        setError('name', err, { shouldFocus: true })
        break

      case 'INVALID_API_TOKEN_NAME_TYPE':
        setError('name', err, { shouldFocus: true })
        break

      default:
        setError('apiError', err)
    }
  }

  const onFormSubmit = async (data) => {
    const payload = { name: data.name }
    const promise = createToken(payload).unwrap()
    promise
      .then(() => {
        reset({ name: '' })
        toast.success('Successfully created API Token')
        onCloseModal()
      })
      .catch((e) => {
        const error = e.data || {}
        switch (error.type) {
          case 'VALIDATION_ERR':
            processError(error.errors[0])
            break

          default:
            processError(error)
        }
      })
    return promise
  }

  const onCloseModal = () => {
    onClose()
    clearErrors()
  }

  const isSubmitDisabled = isSubmitting || createTokenResult.isLoading

  return (
    <Modal
      isOpen={isOpen}
      className='new-design'
      contentLabel='Create Token Modal'
      ariaHideApp={false}
      onRequestClose={onClose}
    >
      <ModalHeader onClose={onCloseModal}>
        <h2>Generate API token</h2>
      </ModalHeader>
      <ModalBody>
        {errors.apiError && <EntryFormError>{errors.apiError.message}</EntryFormError>}
        <form onSubmit={handleSubmit(onFormSubmit)}>
          <FormControl isInvalid={errors.name}>
            <Label> Name </Label>
            <Input type='text' id='name' {...register('name')} />
            {errors.name && <FormErrorText> {errors.name.message} </FormErrorText>}
          </FormControl>
          <Button variant='primary' type='submit' disabled={isSubmitDisabled}>
            Save
          </Button>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default CreateToken
